import MyInput from '../../components/ui/MyInput';
import deleteX from '../../assets/img/deleteX.svg';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import {
  SVG_Add_Square_Bold,
  SVG_Traffic_Bold,
  SVG_Trash_Bin_2_Bold,
  SVG_Trash_Bin_2_Linear,
  SVG_Trash_Bin_2_Outline,
  SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { useNavigate } from 'react-router-dom';
import allTabs from '../DashboardTabs';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import CreateAction from '../../components/operational/createAction';
import useCustomNavigate from '../../components/operational/goBack';
import { v4 as uuid } from 'uuid';
import { TreeSelect } from 'primereact/treeselect';
import store from '../../redux/store';
import { useSelector } from 'react-redux';
import Table from '../../components/ui/Table';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import AddLanguage from './AddLanguage';
import countryCodes from '../../utils/countryCodes.json';
import { Dropdown } from 'primereact/dropdown';
import SecondaryButton from '../../components/ui/SecondaryButton';
import { MultiSelect } from 'primereact/multiselect';
const i18Data = {
  'LOGIN.EMAIL': 'E-posta',
  'LOGIN.EMAIL_INVALID': 'Lütfen geçerli bir e-posta girin',
  'LOGIN.LOGIN': 'Giriş Yap',
  'LOGIN.DONT_HAVE_ACCOUNT': 'Hesabınız yok mu?',
  'LOGIN.SIGN_UP': 'Kaydol',
  'LOGIN.LOGIN_YOUR_ACCOUNT': 'Hesabınıza Giriş Yapın',
  'LOGIN.PASSWORD': 'Şifre',
  'LOGIN.FORGOT_PASSWORD': 'Şifrenizi mi unuttunuz?',
  'LOGIN.EMAIL_REQUIRED': 'E-posta adresi gerekli',
  'LOGIN.PASSWORD_REQUIRED': 'Şifre gerekli',
  'LOGIN.PRIVACY_POLICY_TEXT1': 'Devam ederek,',
  'LOGIN.PRIVACY_POLICY_TEXT2': ' kabul etmiş olursunuz.',
  'LOGIN.PRIVACY_POLICY_TEXT3': ' ',
  'LOGIN.PRIVACY_POLICY': 'Gizlilik Politikasını',
  'LOGIN.DESCRIPTION': 'Hoş Geldiniz, Giriş Yapmak için Bilgilerinizi Girin.',
  'LOGIN.MAIL_PLACEHOLDER': 'Lütfen E-posta adresinizi girin',
  'LOGIN.PASSWORD_PLACEHOLDER': 'Lütfen Şifrenizi girin',
  'LOGIN.REMEMBER_ME': 'Beni hatırla',
  'REGISTER.CREATE_ACCOUNT': 'Hesap Oluştur',
  'REGISTER.CREATE_AN_ACCOUNT_TO_CONTINUE': 'Devam etmek için bir hesap oluşturun',
  'REGISTER.EMAIL': 'E-posta',
  'REGISTER.EMAIL_INVALID': 'Lütfen geçerli bir e-posta girin',
  'REGISTER.LOGIN': 'Giriş Yap',
  'REGISTER.SIGN_UP': 'Kaydol',
  'REGISTER.PASSWORD': 'Şifre',
  'REGISTER.PHONE': 'Telefon',
  'REGISTER.CREATE_YOUR_ACCOUNT': 'Hesabınızı Oluşturun',
  'REGISTER.ALREADY_HAVE_ACCOUNT': 'Zaten hesabınız var mı?',
  'REGISTER.NAME': 'Ad',
  'REGISTER.SURNAME': 'Soyad',
  'REGISTER.EMAIL_REQUIRED': 'E-posta adresi gerekli',
  'REGISTER.FIRST_NAME_REQUIRED': 'Ad gerekli',
  'REGISTER.LAST_NAME_REQUIRED': 'Soyad gerekli',
  'REGISTER.REGISTER_SUCCESS': 'Kayıt başarılı',
  'REGISTER.SHORT_PHONE_NUMBER': 'Telefon numarası çok kısa',
  'REGISTER.PASSWORD_REQUIRED': 'Şifre gerekli',
  'REGISTER.SHORT_PASSWORD': 'Şifre çok kısa',
  'REGISTER.PRIVACY_POLICY_TEXT1': 'Devam ederek,',
  'REGISTER.PRIVACY_POLICY_TEXT2': ' kabul etmiş olursunuz.',
  'REGISTER.PRIVACY_POLICY_TEXT3': ' ',
  'REGISTER.PRIVACY_POLICY': 'Gizlilik Politikasını',
  'FORGOT_PASSWORD.EMAIL': 'E-posta',
  'FORGOT_PASSWORD.EMAIL_INVALID': 'Lütfen geçerli bir e-posta girin',
  'FORGOT_PASSWORD.EMAIL_REQUIRED': 'E-posta adresi gerekli',
  'FORGOT_PASSWORD.PASSWORD_RESET_EMAIL': 'Şifre sıfırlama e-postası gönderildi',
  'FORGOT_PASSWORD.FORGOT_PASSWORD': 'Şifremi unuttum',
  'FORGOT_PASSWORD.RESET_PASSWORD': 'Şifremi Yenile',
  'FORGOT_PASSWORD.SEND': 'Gönder',
  'FORGOT_PASSWORD.DESCRIPTION':
    'Lütfen mail adresinizi giriniz. E-posta yoluyla yeni bir şifre oluşturmak için bir bağlantı alacaksınız.',
  'PROFILE.ORDERS': 'Siparişler',
  'PROFILE.ACCOUNT_SETTINGS': 'Hesap Ayarları',
  'PROFILE.EMAIL': 'E-posta',
  'PROFILE.FAVORITES': 'Favorilerim',
  'PROFILE.WELCOME': 'Hoşgeldiniz',
  'PROFILE.CANCEL': 'İptal',
  'PROFILE.SIGN_WITH_PASSWORD': 'Şifre ile giriş yap',
  'PROFILE.DONT_HAVE_ACCOUNT': 'Hesabınız yok mu?',
  'PROFILE.PRIVACY_POLICY_NOT_FOUND': 'Gizlilik politikası ve diğer bilgiler şu anda mevcut değil',
  'PROFILE.POLICIES': 'Sözleşmeler',
  'PROFILE.SIGN_UP': 'Kaydol',
  'PROFILE.PHONE_NUMBER': 'Telefon Numarası',
  'PROFILE.NAME': 'Ad',
  'PROFILE.SURNAME': 'Soyad',
  'PROFILE.LANGUAGE': 'Dil',
  'PROFILE.LOGOUT_DESCRIPTION': 'Çıkış yapmak istediğinizden emin misiniz?',
  'PROFILE.PAYMENT': 'Ödeme',
  'PROFILE.QTY': 'Miktar',
  'PROFILE.HELP_CENTER': 'Yardım Merkezi',
  'PROFILE.UPDATE': 'Güncelle',
  'PROFILE.TR': 'Türkçe',
  'PROFILE.EN': 'İngilizce',
  'PROFILE.LOGOUT': 'Çıkış Yap',
  'PROFILE.ORDER_PACKAGE_STATUS': 'Paket Durumu',
  'PROFILE.ORDER_PAYMENT_STATUS': 'Ödeme Durumu',
  'PROFILE.DELETE_THE_ACCOUNT_YES': 'Evet, Hesabı Sil',
  'PROFILE.ADDRESS': 'Adreslerim',
  'PROFILE.DELETE_THE_ACCOUNT': 'Hesabı Sil',
  'PROFILE.SUMMARY': 'Özet',
  'PROFILE.ORDER_NUMBER': 'Sipariş Numarası',
  'PROFILE.SHIPPING': 'Kargo',
  'PROFILE.ORDER_DETAIL': 'Sipariş Detayı',
  'PROFILE.PAYMENT_TYPE': 'Ödeme Türü',
  'PROFILE.SELECTED': 'Seçildi',
  'PROFILE.DELETE_THE_ACCOUNT_DETAIL':
    'Hesabınıza tekrar giriş yapmazsanız, bilgileriniz 90 gün sonra kalıcı olarak silinecektir. Onaylıyor musunuz?',
  'PROFILE.PRODUCTS': 'Ürünler',
  'PROFILE.PAYMENT_STATUS': 'Ödeme Durumu',
  'PROFILE.ORDER_STATUS': 'Sipariş Durumu',
  'PROFILE.NO_ORDERS_MESSAGE': 'Şu anda siparişiniz yok',
  'PROFILE.ORDERS_NOT_FOUND': 'Sipariş bulunamadı',
  'PROFILE.SUBTOTAL': 'Ara Toplam',
  'PROFILE.ORDER_DATE': 'Sipariş Tarihi',
  'PROFILE.ADD_ADDRESS': 'Adres Ekle',
  'PROFILE.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ADDRESS': 'Bu adresi silmek istediğinize emin misiniz?',
  'PROFILE.TAX': 'Vergi',
  'PROFILE.TOTAL_PRICE': 'Toplam Fiyat',
  'PROFILE.INVALID_PHONE_NUMBER': 'Gecersiz telefon numarası',
  'PROFILE.REGION_SETTINGS': 'Bölge Ayarları',
  'PROFILE.EDIT_PROFILE': 'Profili Düzenle',
  'PROFILE.NOTIFICATIONS': 'Bildirimler',
  'PROFILE.ORDER.APP_PAYMENT': 'Uygulama Üzerinden Ödeme',
  'PROFILE.ORDER.BANK_REDIRECT': 'Banka Yönlendirme',
  'PROFILE.ORDER.BUY_ONLINE_PAY_AT_STORE': 'Mağazada Ödeme',
  'PROFILE.ORDER.CASH': 'Nakit',
  'PROFILE.ORDER.CASH_ON_DELIVERY': 'Kapıda Nakit Ödeme',
  'PROFILE.ORDER.CREDIT_CARD': 'Kredi Kartı',
  'PROFILE.ORDER.CREDIT_CARD_ON_DELIVERY': 'Kapıda Kredi Kartı',
  'PROFILE.ORDER.DIRECT_DEBIT': 'Doğrudan Borçlandırma',
  'PROFILE.ORDER.GIFT_CARD': 'Hediye Kartı',
  'PROFILE.ORDER.MONEY_ORDER': 'Havale/EFT',
  'PROFILE.ORDER.OTHER': 'Diğer',
  'PROFILE.ORDER.CANCEL_REJECTED': 'İptal Reddedildi',
  'PROFILE.ORDER.CANCEL_REQUESTED': 'İptal Talep Edildi',
  'PROFILE.ORDER.DELIVERED': 'Teslim Edildi',
  'PROFILE.ORDER.FULFILLED': 'Tamamlandı',
  'PROFILE.ORDER.PARTIALLY_DELIVERED': 'Kısmen Teslim Edildi',
  'PROFILE.ORDER.PARTIALLY_FULFILLED': 'Kısmen Tamamlandı',
  'PROFILE.ORDER.PARTIALLY_READY_FOR_SHIPMENT': 'Kısmen Sevkiyata Hazır',
  'PROFILE.ORDER.READY_FOR_PICK_UP': 'Teslim Alınmaya Hazır',
  'PROFILE.ORDER.READY_FOR_SHIPMENT': 'Sevkiyata Hazır',
  'PROFILE.ORDER.REFUND_REQUEST_ACCEPTED': 'İade Talebi Kabul Edildi',
  'PROFILE.ORDER.UNABLE_TO_DELIVER': 'Teslim Edilemedi',
  'PROFILE.ORDER.UNFULFILLED': 'Tamamlanmadı',
  'PROFILE.ORDER.FAILED': 'Başarısız',
  'PROFILE.ORDER.PAID': 'Ödendi',
  'PROFILE.ORDER.PARTIALLY_PAID': 'Kısmen Ödendi',
  'PROFILE.ORDER.WAITING': 'Bekliyor',
  'PROFILE.ORDER.CANCELLED': 'İptal Edildi',
  'PROFILE.ORDER.CREATED': 'Oluşturuldu',
  'PROFILE.ORDER.DRAFT': 'Taslak',
  'PROFILE.ORDER.PARTIALLY_CANCELLED': 'Kısmen İptal Edildi',
  'PROFILE.ORDER.PARTIALLY_REFUNDED': 'Kısmen İade Edildi',
  'PROFILE.ORDER.REFUNDED': 'İade Edildi',
  'PROFILE.ORDER.REFUND_REJECTED': 'İade Talebi Reddedildi',
  'PROFILE.ORDER.REFUND_REQUESTED': 'İade Talep Edildi',
  'PROFILE.ORDER.WAITING_UPSELL_ACTION': 'Ek Satış İşlemi Bekleniyor',
  'CARTS.DELETE': 'Sil',
  'CARTS.SEPERATE_CARGO': 'Ayrı Kargo',
  'CARTS.UNDERWEAR_RETURN': 'İç çamaşırı ve mayo ürünleri iade edilemez ve değiştirilemez.',
  'CATEGORY.CATEGORY': 'Kategori',
  'CATEGORY.NO_SECTIONS_FOUND': 'Bölüm bulunamadı',
  'MOBLIGO_SCREEN.RECENT_THEMES': 'Son Temalar',
  'MOBLIGO_SCREEN.RECENT_THEMES_NOT_FOUND': 'Tema geçmişi boş',
  'MOBLIGO_SCREEN.TR': 'Turkish',
  'MOBLIGO_SCREEN.EN': 'English',
  'CAMPAIGN_SCREEN.CAMPAIGN_NOT_FOUND': 'Kampanyalar henüz mevcut değil.',
  'SEARCH_SCREEN.SEARCH': 'Ara',
  'SEARCH_SCREEN.AGE_CONFIRM': '18 yaşından büyük olduğumu onaylıyorum.',
  'SEARCH_SCREEN.AGE_WARNING': 'Yaş Uyarısı',
  'SEARCH_SCREEN.AGE_DISCLOSURE':
    '18 yaşından küçük bireylerin bu sayfayı gezmesi ve ürün satın alması yasaktır. 18 yaşından küçükseniz ve yasal olarak yetişkin değilseniz, lütfen bu ürünleri görüntülemeyin veya satın almayın.',
  'SEARCH_SCREEN.AGE_CANCEL': '18 yaşından küçüğüm.',
  'VALIDATORS.VALID_NAME': 'Lütfen geçerli bir ad girin',
  'VALIDATORS.VALID_CARD_NUMBER': 'Lütfen geçerli bir kart numarası girin',
  'VALIDATORS.VALID_CVV': 'Lütfen geçerli bir CVV girin',
  'VALIDATORS.THIS_FIELD_IS_MANDATORY': 'Bu alan zorunludur',
  'VALIDATORS.VALIDATE_PASSWORD': 'Şifre en az 6 karakter içermelidir',
  'VALIDATORS.CONFIRM_PASS_VALID_STRING': 'Şifre eşleşmiyor.',
  'VALIDATORS.IS_AVAILABLE': 'mevcut',
  'VALIDATORS.VALID_EMAIL': 'Lütfen geçerli bir e-posta girin',
  'VALIDATORS.PLS_ENTER_PASSWORD': 'Lütfen şifre girin',
  'PRODUCT_DETAIL.UNDERWEAR_RETURN': 'İç çamaşırı ve mayo ürünleri iade edilemez ve değiştirilemez.',
  'PRODUCT_DETAIL.AGE_CONFIRM': '18 yaşından büyük olduğumu onaylıyorum.',
  'PRODUCT_DETAIL.AGE_WARNING': 'Yaş Uyarısı',
  'PRODUCT_DETAIL.AGE_DISCLOSURE':
    '18 yaşından küçük bireylerin bu sayfayı gezmesi ve ürün satın alması yasaktır. 18 yaşından küçükseniz ve yasal olarak yetişkin değilseniz, lütfen bu ürünleri görüntülemeyin veya satın almayın.',
  'PRODUCT_DETAIL.AGE_CANCEL': '18 yaşından küçüğüm.',
  'PRODUCT_DETAIL.TOTAL_PRICE': 'Toplam Fiyat',
  'PRODUCT_DETAIL.PRODUCT_DESCRIPTION': 'Ürün Açıklaması',
  'PRODUCT_DETAIL.NUMBER_OF_PRODUCTS': 'Ürün Adedi',
  'PRODUCT_DETAIL.LAST': 'Son',
  'PRODUCT_DETAIL.PRODUCT': 'Ürün',
  'PRODUCT_DETAIL.STOCK_NOTIFICATION': 'Stok Bildirimi',
  'PRODUCT_DETAIL.THE_PRODUCT_IS_NOT_IN_STOCK': 'Ürün stokta bulunmamaktadır.',
  'PRODUCT_DETAIL.CONTINUE_SHOPPING': 'Alışverişe devam et',
  'PRODUCT_DETAIL.ADD_TO_CART': 'Sepete Ekle',
  'PRODUCT_DETAIL.OUT_OF_STOCK': 'Stokta Yok',
  'PRODUCT_DETAIL.LIMITED_STOCK': 'Tükenmek üzere',
  'PRODUCT_DETAIL.DISCOUNT': 'İndirim',
  'PRODUCT_DETAIL.VARIANT': 'Varyant',
  'PRODUCT_DETAIL.SELECT_SIZE': 'Beden Seçin',
  'HELPERS.UPDATE': 'Güncelle',
  'HELPERS.DISMISS': 'Kapat',
  'HELPERS.UPDATE_APP': 'En son özellikler ve iyileştirmelerden yararlanmak için lütfen uygulamayı güncelleyin',
  'HELPERS.NEW_VERSION': 'Yeni sürüm',
  'HELPERS.PLEASE_DONT_CLOSE_THE_APP': 'Lütfen uygulamayı kapatmayın',
  'HELPERS.UPDATE_CODE_PUSH': 'Güncelleniyor',
  'HELPERS.UPDATE_AVAILABLE': 'Güncelleme Mevcut',
  'HELPERS.WE_ARE_DOING_THE_UPDATE': 'Güncelleme yapıyoruz',
  'TOAST_MESSAGES.SUCCESS': 'Başarılı',
  'TOAST_MESSAGES.THEME_FAIL': 'Tema yüklenemedi',
  'TOAST_MESSAGES.INFORMATION_UPDATED': 'Bilgileriniz başarıyla güncellendi!',
  'ADD_ADDRESS_SCREEN.ERROR': 'Hata',
  'ADD_ADDRESS_SCREEN.ADD_ADDRESS': 'Adres Ekle',
  'ADD_ADDRESS_SCREEN.CONTINUE': 'Devam Et',
  'ADD_ADDRESS_SCREEN.FILL_IN_ALL_FIELDS': 'Tüm alanları doldurun',
  'ADD_ADDRESS_SCREEN.ENTER_VALID_PHONE_NUMBER': 'Gecersiz telefon numarası giriniz',
  'ADD_ADDRESS_SCREEN.ADDRESS_NAME_FOR_EXAMPLE_MY_WORKPLACE': 'Adres Adı, Örneğin İşyerim',
  'ADD_ADDRESS_SCREEN.NAME': 'Ad',
  'ADD_ADDRESS_SCREEN.SURNAME': 'Soyad',
  'ADD_ADDRESS_SCREEN.PHONE_NUMBER': 'Telefon Numarası',
  'ADD_ADDRESS_SCREEN.SAVE_ADDRESS': 'Adresi Kaydet',
  'ADD_ADDRESS_SCREEN.SELECT_CITY': 'İl Secin',
  'ADD_ADDRESS_SCREEN.SELECT_DISTRICT': 'İlçe Secin',
  'ADD_ADDRESS_SCREEN.ADDRESS_DETAIL': 'Adres Detayı',
  'ADD_ADDRESS_SCREEN.APARTMENT_FLAT_ETC': 'Daire, Aparat, vb.',
  'ERROR_POPUP.OK': 'Tamam',
  'ERROR_POPUP.ERROR_MESSAGE': 'Bir hata oluştu.',
  'QR_CAMERA_SCREEN.INVALID_QR': 'Geçersiz QR Kodu',
  'QR_CAMERA_SCREEN.INVALID_QR_DESC': 'Lütfen Mobligo uygulamanız için uygun bir QR kodu tarayın.',
  'QR_CAMERA_SCREEN.ERROR': 'Hata',
  'QR_CAMERA_SCREEN.CONTINUE': 'Devam Et',
  'QR_CAMERA_SCREEN.FLASH': 'Flash',
  'QR_CAMERA_SCREEN.DESCRIPTION': 'Barkodu veya QR kodu, ekranda ayrılmış alana yerleştir.',
  'CAMPAIGNS_SCREEN.CAMPAIGNS': 'Kampanyalar',
  'BRAND_SCREEN.PRODUCT_NOT_FOUND_DETAIL': 'Üzgünüz, ürün bulunamadı.',
  'BRAND_SCREEN.AGE_CONFIRM': '18 yaşından büyük olduğumu onaylıyorum.',
  'BRAND_SCREEN.AGE_WARNING': 'Yaş Uyarısı',
  'BRAND_SCREEN.AGE_DISCLOSURE':
    '18 yaşından küçük bireylerin bu sayfayı gezmesi ve ürün satın alması yasaktır. 18 yaşından küçükseniz ve yasal olarak yetişkin değilseniz, lütfen bu ürünleri görüntülemeyin veya satın almayın.',
  'BRAND_SCREEN.AGE_CANCEL': '18 yaşından küçüğüm.',
  'PRODUCT_CATEGORY.PRODUCT_NOT_FOUND_DETAIL': 'Üzgünüz, ürün bulunamadı.',
  'PRODUCT_CATEGORY.AGE_CONFIRM': '18 yaşından büyük olduğumu onaylıyorum.',
  'PRODUCT_CATEGORY.AGE_WARNING': 'Yaş Uyarısı',
  'PRODUCT_CATEGORY.AGE_DISCLOSURE':
    '18 yaşından küçük bireylerin bu sayfayı gezmesi ve ürün satın alması yasaktır. 18 yaşından küçükseniz ve yasal olarak yetişkin değilseniz, lütfen bu ürünleri görüntülemeyin veya satın almayın.',
  'PRODUCT_CATEGORY.AGE_CANCEL': '18 yaşından küçüğüm.',
  'PRODUCT_CATEGORY.FAILED_TO_FETCH_PRODUCTS': 'Ürünler alınırken hata oluştu.',
  'DISTRICT_SCREEN.DISTRICT_PLACE_HOLDER': 'İlçe seçin',
  'CITY_SCREEN.PLEASE_SELECT_CITY_FIRST': 'Lütfen önce şehir seçin',
  'SHOP_CART_SCREEN.CART': 'Sepet',
  'SHOP_CART_SCREEN.CART_EMPTY': 'Sepetiniz boş',
  'SHOP_CART_SCREEN.CONTINUE_ADD_PRODUCT': 'KEŞFET',
  'SHOP_CART_SCREEN.TOTAL_AMOUNT': 'Toplam Tutar',
  'SHOP_CART_SCREEN.PAY': 'Ödeme Yap',
  'CHECKOUT_SCREEN.GO_TO_MY_PROFILE': 'Profilime git',
  'CHECKOUT_SCREEN.YOUR_ORDER_COULD_NOT_BE_RECEIVED': 'Siparişiniz alınamadı.',
  'CHECKOUT_SCREEN.SORRY_YOUR_ORDER_HAS_FAILED1': 'Üzgünüm! Siparişiniz',
  'CHECKOUT_SCREEN.SORRY_YOUR_ORDER_HAS_FAILED2': 'başarısız oldu.',
  'CHECKOUT_SCREEN.PLEASE_TRY_AGAIN1': 'Bir şeyler yanlış gitti. Lütfen',
  'CHECKOUT_SCREEN.PLEASE_TRY_AGAIN2': 'siparişinize devam etmek için tekrar deneyin.',
  'CHECKOUT_SCREEN.RETURN_TO_HOME_PAGE': 'Ana sayfaya dön',
  'CHECKOUT_SCREEN.VIEW_ORDERS': 'Siparişlerim',
  'CHECKOUT_SCREEN.CONTINUE_SHOPPING': 'Ana sayfa',
  'CHECKOUT_SCREEN.THANK_YOU1': 'Teşekkür Ederiz',
  'CHECKOUT_SCREEN.THANK_YOU2': 'Siparişiniz için!',
  'CHECKOUT_SCREEN.YOUR_ORDER_WILL_BE_DELIVERED_ON_TIME': 'Siparişiniz zamanında teslim edilecektir.',
  'CHECKOUT_SCREEN.THANK_YOU': 'Teşekkürler!',
  'CHECKOUT_SCREEN.ORDER_SUCCESSFUL': 'Sipariş Başarılı',
  'CHECKOUT_SCREEN.GO_TO_ORDERS': 'Siparişlere git',
  'CHECKOUT_SCREEN.COUPON_NOTIFICATION': 'Kupon bildirimi',
  'CHECKOUT_SCREEN.COUPON_APPLIED': 'Kupon uygulandı',
  'CHECKOUT_SCREEN.CONTINUE': 'Devam Et',
  'CHECKOUT_SCREEN.YOUR_COUPON_HAS_BEEN_REMOVED': 'Kuponunuz kaldırıldı.',
  'CHECKOUT_SCREEN.INVALID_COUPON': 'Gecersiz kupon',
  'CHECKOUT_SCREEN.PAY': 'Ödeme Yap',
  'CHECKOUT_SCREEN.SUMMARY': 'Özet',
  'CHECKOUT_SCREEN.PRODUCT': 'Ürün',
  'CHECKOUT_SCREEN.DELIVERY_ADDRESS': 'Teslimat adresi',
  'CHECKOUT_SCREEN.SELECT_DELIVERY_ADDRESS': 'Teslimat adresi seçin',
  'CHECKOUT_SCREEN.PAY_METHODS': 'Ödeme Türü',
  'CHECKOUT_SCREEN.SELECT_PAY_METHOD': 'Ödeme turü seçin',
  'CHECKOUT_SCREEN.CARD_HOLDER_NAME': 'Kart sahibi adı',
  'CHECKOUT_SCREEN.CREDIT_CARD': 'Kredi Kartı',
  'CHECKOUT_SCREEN.CARD_NUMBER': 'Card Number',
  'CHECKOUT_SCREEN.MOUNTH': 'Ay',
  'CHECKOUT_SCREEN.YEAR': 'Yıl',
  'CHECKOUT_SCREEN.CVV': 'CVV',
  'CHECKOUT_SCREEN.TOTAL_PRICE': 'Toplam Tutar',
  'CHECKOUT_SCREEN.REMOVE': 'Kaldır',
  'CHECKOUT_SCREEN.APPLY': 'Uygula',
  'CHECKOUT_SCREEN.ADD_DISCOUNT_CODE': 'İndirim kodu ekle',
  'CHECKOUT_SCREEN.ADD_ORDER_NOTE': 'Sipariş notu ekle',
  'CHECKOUT_SCREEN.SAVE': 'Kaydet',
  'CHECKOUT_SCREEN.COMPLETE_PAYMENT': 'Ödemeyi Tamamla',
  'SELECT_ADDRESS.SELECT_DELIVERY_ADDRESS': 'Teslimat adresi seçin',
  'SELECT_ADDRESS.ADD_ADDRESS': 'Adres ekle',
  'NOTIFICATION_SCREEN.NOTIFICATIONS': 'Bildirimler',
  'HOME_SCREEN.NO_SECTIONS_FOUND': 'Bölüm bulunamadı',
  'FAVORITES_SCREEN.FAVORITES': 'Favoriler',
  'DEFAULT_THEMES_SCREEN.THEME_TEMPLATES': 'Tema Şablonları',
  'DEFAULT_THEMES_SCREEN.MY_DESIGNS': 'Benim Tasarımlarım',
  'DEFAULT_THEMES_SCREEN.DEFAULT_DESIGNS': 'Varsayılan Tasarımlar',
  'CHECKOUT_EXPERIMENT_SCREEN.LOADING': 'Yükleniyor...',
  'CHECKOUT_SCREEN_WEB.TITLE': 'Ödeme Ekranı',
  'BLANK_SCREEN.NO_SECTIONS_FOUND': 'Bölüm bulunamadı',
  'CART_BOTTOM_SHEET.PRODUCT_ADDED': 'Ürün Sepetinizde',
  'CART_BOTTOM_SHEET.GO_CART': 'Sepete git',
  'CART_BOTTOM_SHEET.CONTINUE_SHOPPING': 'Alışverişe devam et',
  'QUICKBUY_MODAL.ADD_TO_CART': 'Sepete Ekle',
  'QUICKBUY_MODAL.PRODUCT_DETAIL': 'Ürün Detayı',
  'QUICKBUY_MODAL.PRODUCT_IN_CART': 'Ürün Sepetinizde',
  'PRODUCT_COMPONENT.OUT_OF_STOCK': 'Tükendi',
  'PRODUCT_COMPONENT.LIMITED_STOCK': 'Tükenmek üzere',
  'PRODUCT_COMPONENT.DISCOUNT': 'İndirim',
  'PRODUCT_COMPONENT.VARIANTS': 'Varyant',
  'CART_COMPONENT.REMOVE': 'Sepetten Kaldır',
  'CART_COMPONENT.REMOVE_FROM_FAVORITE': 'Favorilerden Kaldır',
  'CART_COMPONENT.ADD_TO_FAVORITE': 'Favorilere Ekle',
  'CART_COMPONENT.QUANTITY': 'Adet',
  'error_messages.global.wrong_password': 'Yanlış şifre girişi',
  'error_messages.global.customer_not_found': 'Kullanıcı bulunamadı',
  'error_messages.LOGIN.INVALID_CREDENTIALS': 'Invalid email or password.',
  'error_messages.LOGIN.ACCOUNT_LOCKED': 'Your account has been locked. Please contact support.',
  'error_messages.NETWORK.TIMEOUT': 'The request timed out. Please try again.',
  'error_messages.NETWORK.CONNECTION_LOST': 'Connection lost. Please check your internet.',
  'TOAST.error': 'Hata',
  'TOAST.success': 'Başarılı',
  'TOAST.info': 'Bilgilendirme',
  argument_validation_error: 'Bilgileri tekrardan kontrol edin.',
};

const languages = [
  '🇹🇷 Türkçe',
  '🇬🇧 İngilizce',
  '🇩🇪 Almanca',
  '🇫🇷 Fransızca',
  '🇷🇸 Sırpça',
  '🇷🇴 Romence, Moldovca',
  '🇨🇳 Siçuan Yi, Nuosu',
  '🇵🇫 Tahitice',
  '🇵🇭 Tagalogca',
  '🇮🇱 Yidiş',
  '🇬🇭 Akan',
  '🇲🇾 Malayca',
  '🇸🇦 Arapça',
  '🇳🇴 Norveççe',
  '🇨🇦 Ojibva',
  '🇸🇳 Fulaca',
  '🇮🇷 Farsça',
  '🇦🇱 Arnavutça',
  '🇧🇴 Aymaraca',
  '🇦🇿 Azerice',
  '🇨🇳 Çince',
  '🇨🇦 Kri',
  '🇪🇪 Estonca',
  '🇵🇾 Guarani',
  '🇺🇸 İnyupik',
  '🇨🇦 İnuktitut',
  '🇳🇬 Kanurice',
  '🇷🇺 Komice',
  '🇨🇬 Kongoca',
  '🇮🇶 Kürtçe',
  '🇱🇻 Letonca',
  '🇲🇬 Malgaşça',
  '🇲🇳 Moğolca',
  '🇪🇹 Oromo',
  '🇦🇫 Peştuca',
  '🇵🇪 Keçuva',
  '🇮🇹 Sardunyaca',
  '🇰🇪 Svahili',
  '🇺🇿 Özbekçe',
  '🇨🇳 Cuangca',
  '🇻🇺 Bislama',
  '🇳🇴 Norveççe Bokmål',
  '🇳🇴 Norveççe Nynorsk',
  '🇮🇩 Endonezce',
  '🇬🇭 Tvi',
  '🌐 Esperanto',
  '🌐 İnterlingua',
  '🌐 İnterlingue',
  '🌐 Ido',
  '🇻🇦 Volapük',
  '🇮🇳 Bihar dilleri',
  '🇮🇱 İbranice mdern)',
  '🇮🇳 Sanskrit',
  '🇧🇬 Kilise Slavcası, Eski Slavca, Eski Bulgarca',
  '🇱🇰 Pali',
  '🇮🇷 Avestçe',
  '🌍 Latince',
  '🇦🇲 Ermenice',
  '🇸🇿 Svati',
  '🇨🇳 Tibetçe',
  '🇿🇼 Güney Ndebele',
  '🇸🇮 Slovence',
  '🇮🇳 Oriya',
  '🇿🇼 Kuzey Ndebele',
  '🇳🇷 Nauruca',
  '🇳🇿 Maorice',
  '🇮🇳 Marathice',
  '🇨🇩 Luba-Katanga',
  '🇧🇮 Rundi',
  '🇰🇭 Merkez Khmer',
  '🇳🇱 Batı Frizce',
  '🇧🇩 Bengalce',
  '🇷🇺 Avarca',
  '🇬🇪 Abhazca',
  '🇩🇯 Afarca',
  '🇿🇦 Afrikanca',
  '🇪🇹 Amharca',
  '🇪🇸 Aragonca',
  '🇮🇳 Assamca',
  '🇲🇱 Bambara',
  '🇷🇺 Başkurtça',
  '🇪🇸 Baskça',
  '🇧🇾 Beyaz Rusça',
  '🇧🇦 Boşnakça',
  '🇫🇷 Bretonca',
  '🇧🇬 Bulgarca',
  '🇲🇲 Burmaca',
  '🇪🇸 Katalanca, Valensiyaca',
  '🇬🇺 Çamoroca',
  '🇷🇺 Çeçence',
  '🇲🇼 Çiçevaca',
  '🏴 Kornca',
  '🇫🇷 Korsikaca',
  '🇭🇷 Hırvatça',
  '🇨🇿 Çekçe',
  '🇩🇰 Danca',
  '🇲🇻 Dhivehice, Maldivce',
  '🇳🇱 Felemenkçe',
  '🇧🇹 Dzongkaca',
  '🇬🇭 Evece',
  '🇫🇴 Faroece',
  '🇫🇯 Fijice',
  '🇫🇮 Fince',
  '🇪🇸 Galiçyaca',
  '🇬🇪 Gürcüce',
  '🇬🇷 Yunanca mdern)',
  '🇮🇳 Gucaratça',
  '🇭🇹 Haiti Kreyolu',
  '🇳🇬 Hausa',
  '🇳🇦 Hereroca',
  '🇮🇳 Hintçe',
  '🇵🇬 Hiri Motu',
  '🇭🇺 Macarca',
  '🇮🇪 İrlandaca',
  '🇳🇬 İgbo',
  '🇮🇸 İzlandaca',
  '🇮🇹 İtalyanca',
  '🇯🇵 Japonca',
  '🇮🇩 Cava',
  '🇬🇱 Kalaalisut, Grönlandca',
  '🇮🇳 Kannadaca',
  '🇮🇳 Keşmirce',
  '🇰🇿 Kazakça',
  '🇰🇪 Kikuyu, Gikuyu',
  '🇷🇼 Kinyarvanda',
  '🇰🇬 Kırgızca',
  '🇰🇷 Korece',
  '🇳🇦 Kuanyama',
  '🇱🇺 Lüksemburgca',
  '🇺🇬 Gandaca',
  '🇳🇱 Limburgca',
  '🇨🇩 Lingala',
  '🇱🇦 Laoca',
  '🇱🇹 Litvanca',
  '🇮🇲 Manx',
  '🇲🇰 Makedonca',
  '🇮🇳 Malayalamca',
  '🇲🇹 Maltaca',
  '🇲🇭 Marshallca',
  '🇺🇸 Navaho',
  '🇳🇵 Nepalce',
  '🇳🇦 Ndongaca',
  '🇫🇷 Oksitanca',
  '🇷🇺 Osetçe',
  '🇮🇳 Pencapça',
  '🇵🇱 Lehçe',
  '🇵🇹 Portekizce',
  '🇨🇭 Romanşça',
  '🇷🇺 Rusça',
  '🇵🇰 Sindice',
  '🇳🇴 Kuzey Samice',
  '🇼🇸 Samoaca',
  '🇨🇫 Sangoca',
  '🇬🇧 İskoç Galcesi',
  '🇿🇼 Şonaca',
  '🇱🇰 Sinhalca',
  '🇸🇰 Slovakça',
  '🇸🇴 Somalice',
  '🇱🇸 Güney Soto',
  '🇪🇸 İspanyolca',
  '🇮🇩 Sundaca',
  '🇸🇪 İsveççe',
  '🇱🇰 Tamilce',
  '🇮🇳 Teluguca',
  '🇹🇯 Tacikçe',
  '🇹🇭 Tayca',
  '🇪🇷 Tigrinya',
  '🇹🇲 Türkmence',
  '🇧🇼 Tswana',
  '🇹🇴 Tongaca',
  '🇿🇦 Tsonga',
  '🇷🇺 Tatarca',
  '🇨🇳 Uygurca',
  '🇺🇦 Ukraynaca',
  '🇵🇰 Urduca',
  '🇿🇦 Vendaca',
  '🇻🇳 Vietnamca',
  '🇧🇪 Valonca',
  '🏴 Galce',
  '🇸🇳 Volozca',
  '🇿🇦 Xhosa',
  '🇳🇬 Yorubaca',
  '🇿🇦 Zuluca',
];

const ThemeVariantsAddNew = ({
  tab,
  setIsActive,
  themeVariants,
  getThemeVariants,
  initialThemeVariant,
  setInitialThemeVariant,
  isEdit,
}) => {
  const [selectedThemeVariant, setSelectedThemeVariant] = useState(null);
  const [selectedLanguages, setSelectedLanguages] = useState(null);

  const createNewThemeVariant = async () => {
    if (!selectedThemeVariant?.code || selectedLanguages === '') {
      return;
    }
    const response = await CreateAction({
      method: 'post',
      path: `/themeVariants`,
      showPreLoader: true,
      isFileUploading: false,
      data: {
        sourceThemeVariantId: selectedThemeVariant.code,
        name: selectedLanguages,
      },
    });
    if (response.error) return;
    getThemeVariants();
    setIsActive(false);
    setInitialThemeVariant(null);
  };

  const patchThemeVariant = async () => {
    if (!selectedThemeVariant?.code || selectedLanguages === '') {
      return;
    }
    const response = await CreateAction({
      method: 'patch',
      path: `/themeVariants/${initialThemeVariant.code}`,
      showPreLoader: true,
      isFileUploading: false,
      data: {
        sourceThemeVariantId: initialThemeVariant.code,
        name: selectedLanguages,
      },
    });
    if (response.error) return;
    getThemeVariants();
    setIsActive(false);
    setInitialThemeVariant(null);
  };

  useEffect(() => {
    if (initialThemeVariant) {
      setSelectedLanguages(initialThemeVariant?.name);
    }
  }, []);

  return (
    <>
      <LayeredDashboardHeader
        tab={tab}
        setIsActive={setIsActive}
        onSave={isEdit ? patchThemeVariant : createNewThemeVariant}
        onLeave={() => {
          setIsActive(false);
          setInitialThemeVariant(null);
        }}
      ></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex justify-center items-center flex-col gap-[15px]">
            <div className="bg-white p-[20px] max-w-[1120px]  w-[100%] rounded-[10px]">
              <div className="flex flex-col-reverse lg:flex-row">
                <div className=" mt-[30px] lg:mt-[0px] w-[100%] ">
                  <div className="lg:pr-[20px]">
                    <div className="flex flex-row justify-between items-center">
                      <div className="text-[#333333] text-[18px] font-semibold">Yeni Dil Oluştur</div>
                    </div>

                    <div className="card flex justify-content-center">
                      <Dropdown
                        value={selectedLanguages}
                        onChange={e => setSelectedLanguages(e.value)}
                        options={languages}
                        placeholder="Dil adı seçiniz"
                        filter
                        className="w-full md:w-20rem"
                      />
                    </div>

                    {!isEdit && (
                      <div className="mt-[20px]">
                        <Dropdown
                          value={selectedThemeVariant}
                          options={themeVariants}
                          onChange={e => setSelectedThemeVariant(e.value)}
                          optionLabel="name"
                          placeholder="Kopyalanacak Tema Dili Seçiniz"
                          className="w-[100%]"
                          emptyFilterMessage="Aradığınız kriterlere uygun sonuç bulunamadı"
                          emptyMessage="Listelenecek veri bulunamadı"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {isEdit && (
              <div className="bg-white p-[20px] max-w-[1120px]  w-[100%] rounded-[10px]">
                <div className="flex flex-col-reverse lg:flex-row">
                  <div className=" mt-[30px] lg:mt-[0px] w-[100%] ">
                    <div className="lg:pr-[20px]">
                      <div className="flex flex-row justify-between items-center">
                        <div className="text-[#333333] text-[18px] font-semibold">Çeviriler</div>
                      </div>

                      <DataTable
                        emptyMessage="Kayıt Bulunamadı. "
                        value={Object.keys(i18Data).map(data => {
                          return {
                            name: i18Data[data],
                            code: data,
                          };
                        })}
                        tableStyle={{ minWidth: '50rem' }}
                        rowClassName={''}
                      >
                        <Column field="code" header="Türkçesi"></Column>
                        <Column
                          align="left"
                          field="name"
                          body={rowData => {
                            return (
                              <div className="cursor-not-allowed	opacity-30">
                                <MyInput value={rowData.name} isDiasbled={true}></MyInput>
                              </div>
                            );
                          }}
                          header="Çevirisi"
                        ></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ThemeVariantsAddNew;
